import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import UserTableActions from '@/components/users/UserTableActions.vue';
import type { Company, Role, User } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<User>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.name',
            }),
        sortingFn: 'text',
    },
    {
        accessorKey: 'companies_display',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.companies',
            }),
        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.companies.map((company: Company) => company.name).join(', '),
                size: 'sm',
            });
        },
        sortingFn: 'text',
    },
    {
        accessorKey: 'roles_display_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.roles_display_name',
            }),
        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.roles_display_name,
                size: 'sm',
            });
        },
    },
    {
        accessorKey: 'roles',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.permissions_display_name',
            }),
        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.roles.map((role: Role) => role.description),
                size: 'sm',
            });
        },
    },
    {
        accessorKey: 'has_accepted_invite',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.has_accepted_invite',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_accepted_invite,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'status',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'users.table.status',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.status,
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'status',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(UserTableActions, {
                user: row.original,
            });
        },
    },
];
